/**
 * @owner @Appboy/core-messaging
 */

import { lazy } from "react";

import type { NavigationRoutingObject } from "@navigationRouting/types";

import type { I18nT } from "@lib/dashboardI18n";

const GlobalRateLimits = lazy(() =>
  import("@scenes/GlobalRateLimits").then((module) => ({
    default: module.default.GlobalRateLimits,
  }))
);

export const globalRateLimitsNRO: NavigationRoutingObject = {
  Component: GlobalRateLimits,
  section: "settings",
  componentFeatureFlippers: [],
  noKnockoutFallback: true,
  tag: "new",
  heading: (t: I18nT<"dashboard-navigation">) => t("global-rate-limits-nro-heading", "Messaging Rate Limits"),
  description: (t: I18nT<"dashboard-navigation">) =>
    t("global-rate-limits-nro-description", "Manage Messaging Rate Limits"),
  getDeveloperNavigationAllowed: ({ hasPermission }) => {
    return hasPermission("appGroup", { permission: "viewGlobalRateLimits" });
  },
  additionalSearchTerms: () => [],
  additionalSearchableFeatures: () => ({}),
};
